import { get as lodashGet, findIndex, isNumber } from 'lodash';
import { CHECK_ITEM } from '../../../graphql/shopping-list';
import { UndoAction } from './Action';
import UncheckItemAction from './UncheckItemAction';
import DeleteItemAction from './DeleteItemAction';

/* eslint-disable no-underscore-dangle */

class CheckItemAction extends UndoAction {
  constructor(options) {
    super(options);
    this.item = options.item;
    this.index = options.index;
    this.newIndex = lodashGet(this.undoAction, 'index');
  }

  static get name() { return 'CheckItemAction'; }

  _executeImpl() {
    const shoppingList = this.component.shoppingList;

    // If item already exists on checked list, just delete it
    if (findIndex(shoppingList.items.checked, { externalId: this.item.externalId }) >= 0) {
      return this.component.triggerAction(DeleteItemAction, {
        index: this.index,
        itemListName: 'unchecked',
      });
    }

    const self = this;
    return this.component.$apollo.mutate({
      mutation: CHECK_ITEM,
      variables: {
        id: shoppingList.id,
        itemId: this.item.id,
        newIndex: this.newIndex,
      },
      update(store, { data: { shoppingListCheckItem } }) {
        self._updateCache(store, shoppingListCheckItem);
      },
      optimisticResponse: {
        shoppingListCheckItem: {
          __typename: 'ShoppingListCheckItemResult',
          item: {
            ...self.item,
          },
          modifiedAt: null,
        },
      },
    });
  }

  updateQuery(cachedShoppingList, shoppingListCheckItemResult) {
    cachedShoppingList.items.unchecked.splice(this.index, 1);
    if (isNumber(this.newIndex)) {
      cachedShoppingList.items.checked.splice(this.newIndex, 0, shoppingListCheckItemResult.item);
    } else {
      cachedShoppingList.items.checked.push(shoppingListCheckItemResult.item);
    }

    return cachedShoppingList;
  }

  undo() {
    const index = findIndex(this.component.shoppingList.items.checked, { id: this.item.id });
    if (index < 0) {
      throw new Error('Check item undo failed, item not found.');
    }

    return this.component.triggerAction(UncheckItemAction, {
      index,
      item: this.component.shoppingList.items.checked[index],
      undoAction: this,
    });
  }

  updateItem(oldItem, newItem) {
    if (this.item.id === oldItem.id) {
      this.item = newItem;
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo check item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo check item'; }
}

export default CheckItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/CheckItemAction.js